var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rootContainer"},[_c('div',{staticClass:"cell-center"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"cell-right",on:{"click":_vm.BTActionRightArrow}},[_c('div',[_vm._v("更多")]),_vm._v(" "),_c('van-icon',{staticClass:"arrowRight",attrs:{"name":"arrow"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c642b142","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/panelHeader.vue
// module id = 69l3
// module chunks = 0